import { combineReducers } from 'redux';

import { ContactDetailReducerState, contactDetailReducer } from '../contact-detail/store/contact-detail-reducer';
import { ContactListReducerState, contactListReducer } from '../contact-list/store/contact-list-reducer';

export interface ContactsReducerState {
    contactList: ContactListReducerState;
    contactDetail: ContactDetailReducerState;
}

export const contactsReducer = combineReducers<ContactsReducerState>({
    contactList: contactListReducer,
    contactDetail: contactDetailReducer,
});
